<template>
  <div class="renwu">
    <!-- 问卷介绍 -->
    <div class="titles">
      描述：
      <div class="text">
        <i-input class="textarea" v-model="itemObj.descNote" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="titles">
      标题：
      <div class="text">
        <i-input class="textarea" v-model="itemObj.descTitle" type="text" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="titles">
      内容：
      <div class="text">
        <i-input class="textarea" v-model="itemObj.descContent" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="titles">
      价格：
      <div class="text">
        <i-input class="textarea" v-model="itemObj.descPrice" type="text" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="titles">
      单位：
      <div class="text">
        <i-input class="textarea" disabled v-model="itemObj.descUnit" type="text" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="titles">
      按钮名称：
      <div class="text">
        <i-input class="textarea" v-model="itemObj.btnName" type="text" placeholder="请输入..."></i-input>
      </div>
    </div>
    <div class="btn-cont">
      <Button class="btn fourSize" type="success" ghost @click="sure">确认</Button>
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import {
  getFinishDesc, updateFinishDesc, saveFinishDesc
} from "../servers/api";
export default {
  name: "jiesuan",
  data () {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      isFirst: false,
      itemObj: {
        descNote: '',
        descTitle: '',
        descContent: '',
        descPrice: '',
        descUnit: '元',
        btnName: ''
      }
    };
  },
  created () {
    this.getFinishDescs()
  },
  methods: {
    getFinishDescs () {//获取详情
      getFinishDesc().then(res => {
        if (res.data.code == 10000) {
          if (res.data.data.data.length > 0) {
            this.itemObj = res.data.data.data[0];
            this.isFirst = false;//是不是第一次保存
          } else {
            this.isFirst = true;
          }
        }
      })
    },
    sure () {//点击确认
      if (this.isFirst) {//新增
        saveFinishDesc(this.itemObj).then(res => {
          if (res.data.code == 10000) {
            this.isiconfontshow = false;
            this.alertTitleIshow = true;
            setTimeout(() => {
              this.alertTitleIshow = false;
            }, 2000);
            this.getFinishDescs()
          }
        })
      } else {//修改
        updateFinishDesc(this.itemObj).then(res => {
          if (res.data.code == 10000) {
            this.isiconfontshow = false;
            this.alertTitleIshow = true;
            setTimeout(() => {
              this.alertTitleIshow = false;
            }, 2000);
            this.getFinishDescs()
          }
        })
      }
    }
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  padding-bottom: 80px;
  .titles {
    line-height: 40px;
    font-size: 17px;
  }
  .btn-cont {
    width: 100%;
    height: 70px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .btn {
    float: right;
    margin: 30px;
  }
  .cont {
    word-wrap: break-word;
    line-height: 25px;
    width: calc(100% - 100px);
    padding: 15px;
    margin: 15px;
    margin-left: 40px;
    margin-right: 40px;
    border: 1px dashed #53cac3;
    border-radius: 10px;
    overflow: hidden;
    max-height: 270px;
    overflow-y: visible;
  }
  .text {
    padding: 15px;
  }
  .textarea {
    width: 70%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/questions/questionsJie.vue